export type TTP = {
    filename: string;
    time: string;
    serialNumber?: string;
};

export enum FeedbackType {
    Feedback = 'feedback',
    Feature = 'feature',
    Issue = 'issue'
}
